'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertToFormData = undefined;

var _formData = require('form-data');

var _formData2 = _interopRequireDefault(_formData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Prepare data to formData
 * @param {object} data - data
 * @returns {FormData} - data in format formData
 */
var convertToFormData = exports.convertToFormData = function convertToFormData(data) {
  var formData = new _formData2.default();

  Object.keys(data).forEach(function (key) {
    return formData.append(key, data[key]);
  });

  return formData;
};